var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "14",
        viewBox: "0 0 15 14",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_704_523)" } }, [
        _c("path", {
          attrs: {
            d: "M7.97734 1.00868C7.84392 0.731773 7.56198 0.555557 7.25234 0.555557C6.94271 0.555557 6.66328 0.731773 6.52734 1.00868L4.90868 4.33915L1.29375 4.87283C0.991665 4.91814 0.739929 5.1296 0.646786 5.4191C0.553644 5.7086 0.629165 6.0283 0.845658 6.24228L3.46875 8.83768L2.84948 12.5055C2.79913 12.8076 2.925 13.1147 3.17422 13.2934C3.42344 13.4721 3.75321 13.4948 4.02508 13.3513L7.25486 11.6269L10.4846 13.3513C10.7565 13.4948 11.0863 13.4747 11.3355 13.2934C11.5847 13.1122 11.7106 12.8076 11.6602 12.5055L11.0385 8.83768L13.6615 6.24228C13.878 6.0283 13.9561 5.7086 13.8604 5.4191C13.7648 5.1296 13.5155 4.91814 13.2135 4.87283L9.59601 4.33915L7.97734 1.00868Z",
            fill: "black",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_704_523" } }, [
          _c("rect", {
            attrs: {
              width: "14.5",
              height: "12.8889",
              fill: "white",
              transform: "translate(0 0.555557)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }